// extracted by mini-css-extract-plugin
export default {"imgDiv":"file_imgDiv__Q9qUe","img":"file_img__bzbKg","inputContainer":"file_inputContainer__YkPRe","imgContainer":"file_imgContainer__re1WO","anexosDiv":"file_anexosDiv__lgo+N"};